import React, {useState, useEffect, useRef} from 'react';
import {Unveil} from '@homeaway/react-unveil';
import classNames from 'classnames';
import './ProgressiveImage.less';

const ProgressiveImage = (props) => {
    const ref = useRef();
    const {
        src,
        style,
        className,
        alt,
        fit,
        withWidth = true,
        withHeight = true,
        critical = false,
        ...rest
    } = props;
    const [imgSrc, setImgSrc] = useState('');
    const [loaded, setLoaded] = useState(false);

    function onImageLoad() {
        if (!loaded) {
            setLoaded(true);
        }
    }

    function buildParams() {
        const urlParams = new URLSearchParams();
        const pixelRatio = window.devicePixelRatio || 1;
        const width =
            withWidth && Math.floor(ref.current.clientWidth * pixelRatio);
        const height =
            withHeight && Math.floor(ref.current.clientHeight * pixelRatio);

        /**
         * Filter out string arrays with empty values (false or 0)
         * because Contentful's Image API returns 400 if width or height = 0
         */
        [
            ['fm', 'jpg'],
            ['fl', 'progressive'],
            ['w', width],
            ['h', height],
            ['fit', fit],
        ]
            .filter((item) => !!item[1])
            .forEach((item) => {
                urlParams.append(...item);
            });

        return urlParams.toString();
    }

    useEffect(() => {
        const params = buildParams();
        setImgSrc(`${src}?${params}`);
    }, [src, fit, withWidth, withHeight]);

    const image = imgSrc && (
        <img
            src={imgSrc}
            alt={alt}
            itemProp="image"
            {...rest}
            onLoad={onImageLoad}
            className={classNames('ProgressiveImage__image', {
                'ProgressiveImage__image--loaded': loaded,
            })}
        />
    );

    return (
        <div
            ref={ref}
            style={style}
            className={classNames('ProgressiveImage', className)}
        >
            {critical ? (
                image
            ) : (
                <Unveil useWindowAsScrollParent>{image}</Unveil>
            )}
        </div>
    );
};

export default ProgressiveImage;
